import moment from 'moment';

export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';
export const DISPLAY_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

const formatDisplayDateValue = (
    value?: string | Date | null,
    format: string = DISPLAY_DATE_FORMAT,
    fallback = '-',
): string => {
    if (!value) {
        return fallback;
    }

    const parsed = moment(value);
    if (!parsed.isValid()) {
        return typeof value === 'string' ? value : fallback;
    }

    return parsed.format(format);
};

export const formatDisplayDate = (
    value?: string | Date | null,
    fallback = '-',
): string => formatDisplayDateValue(value, DISPLAY_DATE_FORMAT, fallback);

export const formatDisplayDateTime = (
    value?: string | Date | null,
    fallback = '-',
): string => formatDisplayDateValue(value, DISPLAY_DATE_TIME_FORMAT, fallback);
